import $axios from './config.js'

const _post = (url, data, headers) => {
  return $axios.post(url, data, headers)
}
const _postData = (url, data, headers) => {
  const params = { data: data }
  return $axios.post(url, params, headers)
}
const _get = (url, data, headers={}) => {
  return $axios.get(url, {
    params: data,
    headers
  })
}
const _delete = (url, data, headers) => {
  const params = { data: data }
  return $axios._delete(url, params, headers)
}
const _put = (url, data, headers) => {
  return $axios._delete(url, data, headers)
}
const makeFormData = data => {
  let fd = new FormData()
  for (let key of Object.keys(data)) {
    fd.append(key, data[key])
  }
  return fd
}
const _upload = (url, data, headers) => {
  return $axios.post(url, makeFormData(data), headers)
}
export {
  _get,
  _post,
  _postData,
  _delete,
  _put,
  _upload
}



// WEBPACK FOOTER //
// ./src/axios/request.js